<template>
    <label
        :class="{ 'flex justify-between': optional }"
        class="font-semibold text-gray-800"
    >
        <slot/>
        <span
            v-if="optional"
            class="font-thin italic"
        >
            (optionnel)
        </span>
    </label>
</template>

<script>
export default {
  name: 'BaseLabel',
  props: {
    optional: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>

</style>
